import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm-main',
  templateUrl: './crm-main.component.html',
  styleUrls: ['./crm-main.component.css']
})
export class CrmMainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
